/* eslint-disable import/prefer-default-export */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable brace-style */
/* eslint-disable no-undef */
import { getRetryStrategy } from '@tencent/alloy-cdn-retry-plugin/lib/adapter';
import { monitor } from '@tencent/tencent-doc-report';

const Strategy = getRetryStrategy();
// 可以从 strategy 中拿到统一的资源重试次数（根据retryRoundLimit配置）
const RETRY_TIME = Strategy.getRetryCountLimit();

export function emptyFunc(): void { }

// ajax相关
function createXHR(): XMLHttpRequest | null {
    let xhr: XMLHttpRequest | null = null;

    const XMLHttpFactories = [
        function () {
            return new XMLHttpRequest();
        },
        function () {
            // @ts-ignore
            return new XDomainRequest();
        },
        function () {
            // @ts-ignore
            return new window.ActiveXObject('Msxml2.XMLHTTP');
        },
        function () {
            // @ts-ignore
            return new window.ActiveXObject('Msxml3.xmlhttp');
        },
        function () {
            // @ts-ignore
            return new window.ActiveXObject('Microsoft.XMLHTTP');
        },
    ];

    for (let i = 0, len = XMLHttpFactories.length; i < len; i++) {
        try {
            xhr = XMLHttpFactories[i]();
        } catch (e) {
            continue;
        }
        break;
    }

    return xhr;
}

interface MakeOptsOptions {
    url: string;
    param?: Record<string, string>;
    success?: (data: any) => void;
    fail?: (err: any) => void;
    ajaxType?: string;
}

export function makeOpts(options: MakeOptsOptions) {
    const opts = {
        url: options.url,
        paramObj: options.param || {},
        success: options.success || emptyFunc,
        fail: options.fail || emptyFunc,
        method: options.ajaxType || 'GET',
    };
    opts.method = opts.method.toUpperCase();
    return opts;
}

function makeParam(paramObj: Record<string, string>): string {
    const paramArray: string[] = [];

    // eslint-disable-next-line no-restricted-syntax
    for (const key in paramObj) {
        // eslint-disable-next-line no-prototype-builtins
        if (paramObj.hasOwnProperty(key)) {
            paramArray.push(`${key}=${encodeURIComponent(paramObj[key])}`);
        }
    }

    return paramArray.join('&');
}

export function makeUrl(url: string, paramString: string): string {
    url += (~url.indexOf('?') ? '&' : '?') + paramString;
    return url;
}

// polyfill CustomEvent
export function customEventPolyfill(): void {
    (function () {
        if (typeof window.CustomEvent === 'function') return false;

        function CustomEvent(event: string, parameters) {
            const params = parameters || { bubbles: false, cancelable: false, detail: undefined };
            const evt = document.createEvent('CustomEvent');
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        }

        CustomEvent.prototype = window.Event.prototype;
        // @ts-ignore
        window.CustomEvent = CustomEvent;
    }());
}
customEventPolyfill();

const INIT = -1;
const LOADED = 0; // 加载完毕
const LOADING = 1; // 加载中
const FAIL = 2; // 加载失败

interface ScriptLoaderAsset {
    url: string | null;
    state: number;
    dep?: Record<string, string>;
    loading?: Promise<void>;
}

interface IScriptLoader {
    metadata: any;
    firstLoaded: Record<string, boolean>;
    asset: Record<string, ScriptLoaderAsset> | null;
    assetLoaded: boolean;
    cache: Record<string, any>;
    evtArr: { eventName: string; detail: any }[];
    isIniting: boolean;
    init(asset: string, callback?: () => void, failCb?: (err: any) => void, reTry?: number): void;
    monitor(id: number): void;
    load(
        module: string, callback?: (data: any, cache: Record<string, any>) => void,
        failCb?: (err: any) => void, reTry?: number
    ): void;
    loadScriptProcess(
        param: {
            asset: Record<string, ScriptLoaderAsset>;
            cache: Record<string, any>;
            module: string;
            parentModule: string;
        },
        callback?: (data: any, cache: Record<string, any>) => void,
        failCb?: (err: any) => void, reTry?: number
    ): Promise<void>;
    checkAllLoaded(asset: Record<string, ScriptLoaderAsset>, module: string): boolean;
    createScript(url: string): HTMLScriptElement;
    removeScript(script: HTMLScriptElement): void;
    ajax(options: MakeOptsOptions): void;
    dispatch(eventName: string, detail?: any): void;
    listen(eventName: string, callback?: (event: CustomEvent) => void): void;
}

export const ScriptLoader: IScriptLoader = {
    // 资源映射版本号
    metadata: null,
    // 首次加载成功
    firstLoaded: {},
    // 资源映射
    asset: null,
    // 资源映射是否加载成功
    assetLoaded: false,
    // 已经加载成功的模块缓存
    cache: {},
    // asset.json没加载完之前，存放事件的队列
    evtArr: [],
    isIniting: false,
    /** 拉取资源映射，**初始化函数只应调用一次，重复调用无效** */
    init(asset: string, callback: () => void = emptyFunc, failCb: (err: any) => void = emptyFunc, reTry = 0): void {
        // ScriptLoader 在 player/meeting-room 中被重复初始化，且可能传入不同的 assets
        // 但从当前代码反推设计，init 应只被调用一次，因此在此处 guard
        if (this.assetLoaded) {
            callback?.();
            return;
        }

        if (this.isIniting) {
            console.warn('ScriptLoader is initing');
            return;
        }

        this.isIniting = true;

        if (!reTry) {
            this.asset = this.asset || {};
        }

        // 其它加载逻辑，含有重试
        if (reTry <= 2) {
            const url = `${asset}?_t=${Date.now()}`;
            this.ajax({
                url,
                success: (data) => {
                    this.isIniting = false;

                    this.metadata = data.data.metadata; // 将版本号写入this.metadata字段
                    delete data.data.metadata;       // 去掉metadata
                    delete data.data.ScriptLoader; // 去掉ScriptLoader自身

                    // 将组件及对应依赖写入 this.asset
                    Object.keys(data.data).forEach((item: string) => {
                        this.asset[item] = {
                            url: data.data[item].js || null,
                            state: INIT,
                        };

                        if (data.data[item].dependency) {
                            const dep = data.data[item].dependency;
                            this.asset[item].dep = dep;
                            Object.keys(dep).forEach((depKey: string) => {
                                this.asset[depKey] = {
                                    url: dep[depKey],
                                    state: INIT,
                                };
                            });
                        }
                    });

                    this.assetLoaded = true;
                    // 资源映射返回成功，触发 SL-INIT事件
                    this.dispatch('SL-INIT');
                    callback?.();
                    this.evtArr.forEach((item: { eventName: string; detail: any }) => {
                        this.dispatch(item.eventName, item.detail);
                    });
                    this.monitor(3078347);
                },
                fail: (err) => {
                    this.isIniting = false;

                    window.log.info(err);
                    // 加载资源映射失败，则重试1次，最多3次
                    this.init(asset, callback, failCb, ++reTry);
                    this.monitor(3078348);
                },
            });
        }
        // 超过3次，还没拉取成功，就调用报错callback
        else {
            this.isIniting = false;

            failCb?.({
                code: 1,
                msg: 'load error',
            });
        }
    },
    // monitor 上报
    monitor(id: number): void {
        monitor(id);
    },
    // 加载模块
    // eslint-disable-next-line complexity
    async load(
        module: string, callback: (data: any, cache: Record<string, any>) => void = emptyFunc,
        failCb: (err: any) => void = emptyFunc, reTry = 0,
    ): Promise<void> {
        const { asset } = this;
        const { cache } = this;
        try {
            // 检查组件是否存在于资源映射中
            if (typeof asset[module] !== 'undefined') {
                // 检查组件是否已被缓存，没缓存则进行加载，允许重试3次
                if (typeof cache[module] === 'undefined' && reTry <= RETRY_TIME) {
                    // 检测js依赖
                    if (asset[module].dep) {
                        const loadingDep: Promise<void>[] = [];
                        Object.keys(asset[module].dep).forEach((depKey: string) => {
                            // 如果全局有了，就直接使用，并标记加载完成
                            if (window[depKey]) {
                                cache[depKey] = window[depKey];
                                asset[depKey].state = LOADED;
                            }
                            // 如果全局没有，且没缓存，且并非正在加载的依赖，则开始加载
                            else if (typeof cache[depKey] === 'undefined' && asset[depKey].state === INIT) {
                                asset[depKey].loading = this.loadScriptProcess({
                                    asset,
                                    cache,
                                    module: depKey,
                                    parentModule: module,
                                }, callback, failCb, reTry);
                                loadingDep.push(asset[depKey].loading);
                            } else {
                                loadingDep.push(asset[depKey].loading);
                            }
                        });
                        await Promise.all(loadingDep);
                    }

                    // 如果没有正在加载，则开始加载，多处调用时，避免重复加载
                    if (asset[module].state === INIT) {
                        this.loadScriptProcess({
                            asset,
                            cache,
                            module,
                            parentModule: module,
                        }, callback, failCb, reTry);
                    }
                }
                // 如果被缓存，而且所有依赖都加载完毕，则执行回调
                else if (cache[module] && this.firstLoaded[module] && this.checkAllLoaded(asset, module)) {
                    // console.log('----456----');
                    callback(cache[module], cache);
                    this.firstLoaded[module] = true;
                }
            } else {
                window.log.info(`${module} is not found.`);
                failCb?.({
                    code: 1,
                    msg: `${module} is not found.`,
                });
            }
        } catch (e) {
            window.log.info(`${module} load error`, e);
            // 执行回调或加载报错
            this.monitor(3078382);
            failCb?.({
                code: 2,
                msg: e,
            });
        }
    },

    // 加载script的过程
    /**
     *
     * @param {Object} param0 asset 资源映射 组件缓存 加载模块（可能是依赖模块也可能是主模块） 资源映射的主模块
     * @param {Function} callback 调用回调
     * @param {Integter} reTry 重试次数
     */
    loadScriptProcess(
        { asset, cache, module, parentModule },
        callback: (data: any, cache: Record<string, any>) => void = emptyFunc,
        failCb: (err: any) => void = emptyFunc, reTry = 0,
    ): Promise<void> {
        return new Promise((resolve, reject) => {
            // 根据重试策略获取新的资源路径
            const requestUrl = Strategy.findRequestUrl(asset[module].url!, reTry);
            let script: HTMLScriptElement | null = null;
            script = this.createScript(requestUrl);
            asset[module].state = LOADING;


            script?.addEventListener('load', () => {
                if (window[module]) {
                    /*
                    * 通知 docs-cdn-retry 资源加载成功
                    * emitLoadSuccessEvent 的时机要尽量提前，保证其他资源加载时能正确获取到最优域名
                    */
                    Strategy.emitLoadSuccessEvent(requestUrl, { resourceType: 'JS', retryCount: reTry });

                    cache[module] = window[module];
                    asset[module].state = LOADED;

                    if (!this.firstLoaded[parentModule] && this.checkAllLoaded(asset, parentModule)) {
                        callback(cache[parentModule], cache);
                    }
                    // 加载js成功
                    this.monitor(3078345);
                    resolve();
                }
            });

            script?.addEventListener('error', () => {
                /*
                * 通知 docs-cdn-retry 资源加载失败
                * emitLoadFailedEvent 执行的时机要在下次 load 之前，保证下次资源加载前把当前最优域名清掉
                */
                Strategy.emitLoadFailedEvent(requestUrl, { resourceType: 'JS', retryCount: reTry });

                // 重试三次如果都失败，才设置成失败
                if (reTry >= RETRY_TIME) {
                    reject();
                    asset[module].state = FAIL;
                } else {
                    asset[module].state = INIT;
                }

                asset[module].url = requestUrl;

                this.load(module, callback, failCb, ++reTry);
                script && this.removeScript(script);

                failCb?.({
                    code: 3,
                    msg: 'load error',
                });
                // 加载js失败
                this.monitor(3078346);
            });
        });
    },
    // 检测是否父模块及其所有依赖都已经加载完毕，若是，则执行回调
    checkAllLoaded(asset: Record<string, ScriptLoaderAsset>, module: string): boolean {
        const info = asset[module];
        if (asset[module].state !== LOADED) {
            // console.log(module, 1);
            return false;
        }

        // console.log(info.dep);
        if (typeof info.dep !== 'undefined') {
            const deps = Object.keys(info.dep);
            // console.log(deps);
            for (let i = 0, len = deps.length; i < len; i++) {
                if (!window[deps[i]]) {
                    // console.log(module, 2);
                    return false;
                }
            }
        }

        // 首次加载完成
        this.firstLoaded[module] = true;
        return true;
    },
    // 创建script
    createScript(url: string): HTMLScriptElement {
        const script = document.createElement('script');
        script.src = url;
        script.async = false;
        script.type = 'text/javascript';
        if (url.indexOf(document.domain) === -1) {
            script.crossOrigin = 'anonymous';
        }
        document.body.appendChild(script);
        return script;
    },
    // 去除script
    removeScript(script: HTMLScriptElement): void {
        if (script?.parentNode) {
            script.parentNode.removeChild(script);
        }
    },
    // ajax 请求相关
    ajax(options: MakeOptsOptions): void {
        const opts = makeOpts(options);
        const paramString = makeParam(opts.paramObj);
        const url = makeUrl(opts.url, paramString);
        const xhr = createXHR();

        if (!xhr) {
            throw new Error('XMLHttp is not defined');
        }

        xhr.open('GET', url, true);
        // xhr.withCredentials = true;
        // xhr.setRequestHeader && xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhr.send();

        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    const data = JSON.parse(xhr.responseText);
                    opts.success({
                        data,
                        code: 0,
                    });
                    this.monitor(3078349);
                } else {
                    opts.fail({
                        code: xhr.status,
                    });

                    if (xhr.status >= 400 && xhr.status < 500) {
                        this.monitor(3078350);
                    } else if (xhr.status >= 500 && xhr.status < 600) {
                        this.monitor(3078351);
                    }
                }
            }
        };

        xhr.onerror = () => {
            opts.fail({
                code: -1,
            });
        };
    },
    // CustomEvent 分发
    dispatch(eventName: string, detail?: any): void {
        // asset.json没加载完，先将事件推入队列中
        if (!this.assetLoaded) {
            this.evtArr.push({ eventName, detail });
            return;
        }

        const evt = new window.CustomEvent(eventName, {
            detail,
        });

        window.dispatchEvent(evt);
        // console.log(`dispatch ${eventName} event`);
    },
    // CustomEvent 监听
    listen(eventName: string, callback: (event: CustomEvent) => void = emptyFunc): void {
        window.addEventListener(eventName, callback);
        // console.log(`listen ${eventName} event`);
    },
};

if (!window.ScriptLoader) {
    window.ScriptLoader = ScriptLoader;
}
window.SLR = ScriptLoader;
